import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import DropDown from '../ui/react-ui/dropdown';
import { getAreaGates } from '../../api/areaAPI';
import { getPredictionGatesItt } from '../../api/predictionAPI';
import { setDialogMode, setDialogInfo } from '../../redux/traffic-live';
var t = i18n.getFixedT(null, 'traffic-live');
var ForecastPassingTime = /*#__PURE__*/React.memo(function () {
  // redux data, dispatch
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      zoneIdStart = _useState2[0],
      setZoneIdStart = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      zoneIdEnd = _useState4[0],
      setZoneIdEnd = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      zoneStartList = _useState6[0],
      setZoneStartList = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      zoneEndList = _useState8[0],
      setZoneEndList = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      gateStartList = _useState10[0],
      setGateStartList = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      gateIdStart = _useState12[0],
      setGateIdStart = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray(_useState13, 2),
      gateEndList = _useState14[0],
      setGateEndList = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      gateIdEnd = _useState16[0],
      setGateIdEnd = _useState16[1];

  var _useState17 = useState(''),
      _useState18 = _slicedToArray(_useState17, 2),
      errorMessage = _useState18[0],
      setErrorMessage = _useState18[1];

  var _isMounted = useRef(false); // create select list


  var createSelectList = function createSelectList(data) {
    return _.map(data, function (el) {
      return {
        value: el.id,
        text: el.name
      };
    });
  }; // clear


  var handleClear = function handleClear() {
    setZoneIdStart('');
    setZoneIdEnd('');
    setErrorMessage('');
  }; // confirm


  var handleConfirm = function handleConfirm() {
    if (_.isEmpty(gateIdStart) || _.isEmpty(gateIdEnd)) return setErrorMessage(t('txt-must-selected-gates'));
    getPredictionGatesItt(contextRoot, gateIdStart, gateIdEnd).then(function (result) {
      setErrorMessage('');

      var startZoneText = _.find(zonesList, function (o) {
        return o.value === zoneIdStart;
      }).text;

      var startGateText = _.find(gateStartList, function (o) {
        return o.value === gateIdStart;
      }).text;

      var endZoneText = _.find(zonesList, function (o) {
        return o.value === zoneIdEnd;
      }).text;

      var endGateText = _.find(gateEndList, function (o) {
        return o.value === gateIdEnd;
      }).text;

      var dialogData = _objectSpread(_objectSpread({}, result.content[0]), {}, {
        startArea: startZoneText + '-' + startGateText,
        endArea: endZoneText + '-' + endGateText
      });

      dispatch(setDialogInfo({
        mode: 'forecastPassingTime',
        data: dialogData
      }));
    });
  }; // zone start selected event


  useEffect(function () {
    if (_isMounted.current === false) return; // filter zoneEndlist

    var newZoneEndList = _.filter(zonesList, function (el) {
      return el.value !== zoneIdStart;
    });

    setZoneEndList(newZoneEndList);
    setGateIdStart('');
    if (zoneIdStart === '') return setGateStartList([]);
    getAreaGates(contextRoot, null, zoneIdStart).then(function (result) {
      var gateList = createSelectList(result.content);
      setGateStartList(gateList);
    });
  }, [zoneIdStart]); // zone end selected event

  useEffect(function () {
    if (_isMounted.current === false) return; // filter zoneStartlist

    var newZoneStartList = _.filter(zonesList, function (el) {
      return el.value !== zoneIdEnd;
    });

    setZoneStartList(newZoneStartList);
    setGateIdEnd('');
    if (zoneIdEnd === '') return setGateEndList([]);
    getAreaGates(contextRoot, null, zoneIdEnd, null, null, null, gateIdStart).then(function (result) {
      var gateList = createSelectList(result.content);
      setGateEndList(gateList);
    });
  }, [zoneIdEnd]);
  useEffect(function () {
    setZoneIdEnd('');
    setGateIdEnd('');
    setGateEndList([]);
  }, [gateIdStart]);
  useEffect(function () {
    if (_isMounted.current === false) {
      setZoneStartList(zonesList);
      setZoneEndList(zonesList);
      _isMounted.current = true;
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "forecastPassingTime"
  }, /*#__PURE__*/React.createElement("div", {
    className: "start-area"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-select-start-area')), /*#__PURE__*/React.createElement("label", null, t('lbl-terminal-center')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: zoneStartList,
    value: zoneIdStart,
    onChange: function onChange(val) {
      return setZoneIdStart(val);
    },
    width: "300px"
  }), /*#__PURE__*/React.createElement("label", {
    className: 'mgt2'
  }, t('lbl-gate-station')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: gateStartList,
    value: gateIdStart,
    onChange: function onChange(val) {
      return setGateIdStart(val);
    },
    width: "300px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "destination"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-select-destination')), /*#__PURE__*/React.createElement("label", null, t('lbl-terminal-center')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: zoneEndList,
    value: zoneIdEnd,
    onChange: function onChange(val) {
      return setZoneIdEnd(val);
    },
    width: "300px"
  }), /*#__PURE__*/React.createElement("label", {
    className: 'mgt2'
  }, t('lbl-gate-station')), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-select'),
    list: gateEndList,
    value: gateIdEnd,
    onChange: function onChange(val) {
      return setGateIdEnd(val);
    },
    width: "300px"
  })), /*#__PURE__*/React.createElement("div", {
    className: "error"
  }, errorMessage), /*#__PURE__*/React.createElement("div", {
    className: "c-flex fdr fww jcsb action"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button clear",
    onClick: handleClear
  }, t('lbl-clear')), /*#__PURE__*/React.createElement("button", {
    className: "button confirm",
    onClick: handleConfirm
  }, t('lbl-confirm'))));
});
export default ForecastPassingTime;